<mat-select [tabIndex]="tabIndex" [formControl]="selectCtrl" [compareWith]="compareFn"
    (selectionChange)="onSelectionChange()">
    <mat-option *ngFor="let salesRouteLevel of salesRouteLevels" [value]="salesRouteLevel">{{ salesRouteLevel.name
        }}</mat-option>
</mat-select>

<mat-progress-spinner *ngIf="loading === true" diameter="16" mode="indeterminate"></mat-progress-spinner>